export var MINI_BAG_AT_ACTIVITY_NAME = 'EXP1-MYBAG-5454_GLOBAL_WEB_AB_MOBILE/DESKTOP_mini-bag-phase-1_PROD_1';
export var MINI_BAG_AT_EXPERIENCES = ['A', 'B', 'C'];
export var MINI_BAG_AT_LOCATION_NAME = 'cartux_mini_bag';
var temporaryActionEnumsPromise;
var getTemporaryActionEnums = function getTemporaryActionEnums() {
  var _window, _analytics$utils;
  var analytics = (_window = window) === null || _window === void 0 || (_window = _window.webShellClient) === null || _window === void 0 ? void 0 : _window.analytics;
  if (!(analytics !== null && analytics !== void 0 && (_analytics$utils = analytics.utils) !== null && _analytics$utils !== void 0 && _analytics$utils.getProtoEnums)) {
    return Promise.resolve(null);
  }
  if (!temporaryActionEnumsPromise) {
    temporaryActionEnumsPromise = analytics.utils.getProtoEnums('TemporaryActionType')["catch"](function (error) {
      temporaryActionEnumsPromise = undefined;
      throw error;
    });
  }
  return temporaryActionEnumsPromise;
};
var trackMiniBagAction = function trackMiniBagAction(_ref) {
  var _window2;
  var actionName = _ref.actionName,
    cohort = _ref.cohort;
  var analytics = (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.webShellClient) === null || _window2 === void 0 ? void 0 : _window2.analytics;
  if (!(analytics !== null && analytics !== void 0 && analytics.trackAction)) {
    return;
  }
  getTemporaryActionEnums().then(function (tempActionEnums) {
    if (!(tempActionEnums !== null && tempActionEnums !== void 0 && tempActionEnums.CLICK)) {
      return;
    }
    analytics.trackAction({
      underlyingAction: {
        "case": 'temporaryAction',
        value: {
          actionName: actionName,
          type: tempActionEnums.CLICK,
          experiment: {
            activityName: MINI_BAG_AT_ACTIVITY_NAME,
            cohort: cohort
          }
        }
      }
    }, {
      eventVersion: 2
    });
  })["catch"](function () {});
};
export default trackMiniBagAction;